import jQuery from 'jquery';
import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import './styles/Notificacao.css';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import { smoothlyMenu } from '../helpers';
import miniLogo from '../../assets/images/img/LarisSobre.png';

import ProgressBar from '../../utils/progressBar';
import Util from '../../helpers/util';
import { sendErroRequest, createErrorNotification } from '../../utils/Notification';

import { carregarRelatorios, limparListaRelatorio, logOutUser } from '../../actions';

const TopNavbar = ({ pessoaLogada }) => {
  const [showModal, setShowModal] = useState(false);
  const ref = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(carregarRelatorios());
    return () => {
      cleanRelatorios();
    };
  }, [dispatch]);

  const relatorioData = useSelector((state) => state.relatorio);

  const toggleNavigation = (e) => {
    e.preventDefault();
    jQuery('body').toggleClass('mini-navbar');
    smoothlyMenu();
  };

  function refreshPage() {
    window.location.reload();
  }

  function cleanRelatorios() {
    sessionStorage.setItem('messages', JSON.stringify([]));
    this.forceUpdate();
  }

  function logout() {
    dispatch(logOutUser());
  }

  const content = (
    <div
      className={relatorioData.relatorios.length > 0 ? 'pre-scrollable' : 'row'}
      style={{ height: relatorioData.relatorios.length > 0 ? 120 : 30 }}>
      {relatorioData.relatorios.length > 0 ? (
        relatorioData.relatorios.map((item) => {
          const fileName = item.nome;

          const downloadFile = async (url, nomeArquivoParaDownload) => {
            try {
              const { blob } = await Util.obterBlobDocumento(url);

              const link = document.createElement('a');
              const urlBlob = window.URL.createObjectURL(blob);
              link.href = urlBlob;
              if (item.nome.includes('Planilha_')) {
                link.download = `${nomeArquivoParaDownload}.xlsx`;
              } else {
                link.download = `${nomeArquivoParaDownload}.pdf`;
              }
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(urlBlob);
            } catch (err) {
              if (err && err.isCustomError) {
                createErrorNotification(err.message);
              } else {
                sendErroRequest(err, 'Ocorreu um erro ao realizar o download do relatório.');
              }
            }
          };
          return (
            <div key={item.id}>
              <p
                className="rowRelatorio"
                style={{
                  minWidth: `${(window.innerWidth * 15) / 100}`,
                  marginRight: 15,
                  textAlign: 'right',
                  fontSize: '12px',
                }}>
                {item.nome}

                <button
                  className="`btn btn-primary m-t"
                  type="button"
                  onClick={() => downloadFile(item.url, fileName)}
                  style={{ marginLeft: '5px', border: '1px solid' }}>
                  <i className="fa fa-download fa-1x" />
                </button>
              </p>
            </div>
          );
        })
      ) : (
        <div className="col-md-12">{<span>Nada por aqui</span>}</div>
      )}
    </div>
  );
  const linearBarProgress = (
    <div style={{ textAlign: 'center' }}>
      {' '}
      <ProgressBar />
      {<span>Processando</span>}
    </div>
  );

  function Titulo() {
    return (
      <div style={{ textAlign: 'center' }}>
        <a href="#/gerenciador-relatorios">Gerenciador de Relatórios</a>
        {relatorioData.relatorios.length > 0 && (
          <Tooltip title="Limpar gerenciador de relatórios!" className="pull-right">
            <div style={{ marginTop: 3 }}>
              <a onClick={() => dispatch(limparListaRelatorio())}>
                <i className="fa fa-trash" />
              </a>
            </div>
          </Tooltip>
        )}
      </div>
    );
  }

  const handleShowModal = () => setShowModal(true);

  const closeModal = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setShowModal(false);
    }
  };

  const handleEscKey = (e) => {
    if (e.key === 'Escape') {
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      setTimeout(() => {
        document.addEventListener('click', closeModal);
        document.addEventListener('keydown', handleEscKey);
      }, 50);
    }

    return () => {
      document.removeEventListener('click', closeModal);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [showModal]);

  const modalContent = (
    <div
      style={{
        position: 'relative',
        backgroundImage: `url(${miniLogo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '50px',
        width: '100%',
        height: '300px',
        textAlign: 'left',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <div
        style={{
          position: 'absolute',
          left: '10px',
          bottom: '20px',
          textAlign: 'left',
        }}>
        <h4 style={{ color: 'gray' }}>
          Versão <i>3.0.19</i>
        </h4>
        <button
          className="btn btn-info"
          style={{
            marginRight: '10px',
            backgroundColor: '#4585d3',
          }}
          onClick={handleShowModal}>
          <a
            href="https://lariscondominios.com.br/blog/"
            style={{ color: '#fff', textDecoration: 'none' }}
            target="_blank">
            Boletim de Informações Técnicas
          </a>
        </button>
      </div>
    </div>
  );

  return (
    <div className="row border-bottom">
      <nav className="navbar navbar-static-top" role="navigation" style={{ marginBottom: 0 }}>
        <div className="navbar-header">
          <a
            className="minimalize-styl-2 btn btn-primary"
            onClick={(e) => toggleNavigation(e)}
            href="#">
            <i className="fa fa-bars" />
          </a>
        </div>
        <ul className="nav navbar-top-links navbar-right">
          <li>
            <Tooltip title="Versão Laris">
              <button
                className="btn btn-info"
                style={{
                  marginRight: '10px',
                  backgroundColor: '#4585d3',
                  color: '#fff',
                }}
                onClick={handleShowModal}>
                Sobre
              </button>
            </Tooltip>
          </li>
          <li>
            <Tooltip title="Central de Atendimento!">
              <a href="https://atendimento.tron.com.br" target="_blank">
                Central de Atendimento
              </a>
            </Tooltip>
          </li>
          <li>
            <Tooltip title="Recarregar página!">
              <button
                type="button"
                className="btn btn-default"
                data-toggle="tooltip"
                data-placement="bottom"
                data-original-title="Tooltip on bottom"
                style={{ marginRight: '10px', background: 'none', border: 'none' }}
                onClick={() => refreshPage()}>
                <i className="fa fa-refresh" />
              </button>
            </Tooltip>
          </li>
          <li className="dropdown">
            <Tooltip title="Notificações">
              <a
                className="dropdown-toggle count-info"
                data-toggle="dropdown"
                href="#"
                aria-expanded="false">
                <i className="fa fa-bell" />
                {relatorioData?.relatorios?.length > 0 && (
                  <span className="label label-primary">{relatorioData?.relatorios?.length}</span>
                )}
              </a>
            </Tooltip>
            <ul className="dropdown-menu dropdown-alerts">
              <li>
                <div>
                  <Titulo />
                </div>
              </li>
              <li className="dropdown-divider" />

              <li>
                <div style={{ textAlign: 'center' }}>
                  {relatorioData.aguardandoRelatorio === false ? content : linearBarProgress}
                </div>
              </li>
            </ul>
          </li>
          <li>
            <a
              href={process.env.REACT_APP_SENTINELA}
              onClick={() => logout()}
              style={{ marginRight: '25px' }}>
              <i className="fa fa-sign-out" /> Sair
            </a>
          </li>
          {showModal && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}>
              <div
                ref={ref}
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  maxWidth: '500px',
                  width: '100%',
                  textAlign: 'center',
                }}>
                {modalContent}
              </div>
            </div>
          )}
        </ul>
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pessoaLogada: state.usuario.pessoaLogada,
  relatorio: state.relatorio,
});

export default connect(mapStateToProps)(TopNavbar);
